import { sortBy } from 'lodash-es';
import { getChannelOption, getSubChannels, isParent } from 'utils';
import { countries, languages } from 'components/forms/data';
import { navigationItemModel } from 'common/api/models';
import { FIELDS } from 'components/forms';

export const sortOptions = (options, option, sortedOptions) => {
  sortedOptions.push(option);
  if (isParent(options, option)) {
    const children = getSubChannels(options, option);
    children.map((child) => sortOptions(options, child, sortedOptions));
  }
};

export const getChannelsOptions = (channels) => {
  const options = channels.map(navigationItemModel).map((channel) => getChannelOption(channel, channels));
  const sortedOptions = [];

  options.filter((option) => option.parentId === null).map((option) => sortOptions(options, option, sortedOptions));

  return sortedOptions;
};

const mapSelectOption = (value) => ({ id: value, value, label: value });
export const getKeywordsOptions = (keywords) => keywords.map(mapSelectOption);

/**
 * @param {string} sortByKey
 * @return {{iso: string, native: string}[]}
 */
export const getSortedLangs = (sortByKey = 'iso') => {
  return sortBy(languages, [sortByKey]);
};

/**
 * @return {string|null}
 */
export const getCountries = (lang) => {
  return countries[lang.slice(0, 2)];
};

/**
 *
 * @param {{[number]: number}|null} chunksProgress
 * @param {number} totalChunks
 * @return {{[number]: number}}
 */
export const handleChunksProgress = (chunksProgress, totalChunks) => {
  if (chunksProgress) {
    return chunksProgress;
  }

  let i = 1;
  let buffer = {};
  while (i <= totalChunks) {
    buffer[i] = 0;
    i++;
  }

  return buffer;
};

/**
 * @param {{[number]: number}} chunksProgress
 * @return {number}
 */
export const calculateOverallProgress = (chunksProgress) => {
  const keys = Object.keys(chunksProgress);
  const accumulatedProgress = keys.reduce((acc, chunkNumber) => {
    const currentChunkProgress = chunksProgress[chunkNumber];
    return acc + currentChunkProgress;
  }, 0);

  return Math.floor(accumulatedProgress / keys.length);
};

/**
 *
 * @param file
 * @param chunkSize
 * @returns {Array}
 */
export function splitFileIntoChunks(file, chunkSize) {
  const total = file.size;
  const chunks = [];
  let chunked = 0;
  while (chunked < total) {
    const end = Math.min(chunked + chunkSize, total);
    chunks.push(file.slice(chunked, end));
    chunked += chunkSize;
  }
  return chunks;
}

/**
 * @param {string} field - one of FIELDS.
 * @example FIELDS.CHANNEL_SELECT, FIELDS.LANGUAGE_SELECT, ......
 * @return {boolean}
 */
export const isFormFieldSelectbox = (field) =>
  [FIELDS.CHANNEL_SELECT, FIELDS.COUNTRY_SELECT, FIELDS.LANGUAGE_SELECT, FIELDS.KEYWORDS].some((c) => c === field);
